import { Trans } from "@lingui/macro";
import { useLingui } from "@lingui/react";
import { useNavigate } from "react-router";
import { ArrowRight } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AuthShell } from "./AuthShell";

const AUTH_CARD_MIN_H = "min-h-[540px]";

export function WelcomePage() {
  const navigate = useNavigate();
  useLingui();

  return (
    <AuthShell>
      <Card className="w-full max-w-md rounded-2xl shadow-sm">
        <CardContent
          className={`flex flex-col items-center text-center px-8 pt-12 pb-12 ${AUTH_CARD_MIN_H}`}
        >
          <div className="flex flex-col items-center gap-4">
            <img
              src="/favicon-512.png"
              alt="Daycare Butler"
              className="h-24 w-24 rounded-2xl"
              width={96}
              height={96}
            />
            <h1 className="text-xl font-semibold">Daycare Butler</h1>
            <h2 className="text-2xl font-bold mt-2">
              <Trans id="auth.welcome.title">Welcome back</Trans>
            </h2>
            <p className="text-sm text-muted-foreground">
              <Trans id="auth.welcome.subtitle">
                Sign in to continue to your daycare.
              </Trans>
            </p>
          </div>
          <Button
            className="w-full mt-auto"
            size="lg"
            onClick={() => navigate("/sign-in")}
          >
            <Trans id="auth.welcome.signIn">Sign in</Trans>
            <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
        </CardContent>
      </Card>
    </AuthShell>
  );
}

export { AUTH_CARD_MIN_H };
